import './bootstrap';

import Vue from 'vue';
/* import {ref} from 'vue'; */

import vSelect from 'vue-select'


import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-select/dist/vue-select.css';
import flatPickr from 'vue-flatpickr-component';
/* import {Indonesian} from 'flatpickr/dist/l10n/id.js'; */
import VueQuillEditor from 'vue-quill-editor';
import Notifications from 'vue-notification';
import Multiselect from 'vue-multiselect';
import VeeValidate from 'vee-validate';
import 'flatpickr/dist/flatpickr.css';
import VueCookie from 'vue-cookie';
import { Admin } from 'craftable';
/* import VueExcelEditor from 'vue-excel-editor' */

/* const config = ref({
    wrap: true, // set wrap to true only when using 'input-group'
    altFormat: 'M j, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
    locale: Indonesian, // locale for this instance only          
}); */

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import VModal from 'vue-js-modal'

import './app-components/bootstrap';
import './index';

import 'craftable/dist/ui';


/* import VueNumeric from 'vue-numeric'
Vue.use(VueNumeric) */
Vue.component('v-select', vSelect)

import VueNum from '../admin/app-components/vue-num.vue'
Vue.component('vue-numeric', VueNum);

import LogDetail from '../admin/app-components/log-detail.vue'
Vue.component('LogDetail', LogDetail);

Vue.component('multiselect', Multiselect);
Vue.component('DatePicker', DatePicker );
Vue.use(VeeValidate, {strict: true});
Vue.component('datetime', flatPickr);
Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true });
Vue.use(VueQuillEditor);
Vue.use(Notifications);
Vue.use(VueCookie);
/* Vue.use(VueExcelEditor) */

new Vue({
    mixins: [Admin],
});